/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskRemintedFromTaskId } from './taskRemintedFromTaskId';
import type { TaskTypeEnum } from './taskTypeEnum';
import type { TaskAnalysis } from './taskAnalysis';
import type { TaskGradingSystemProperty } from './taskGradingSystemProperty';
import type { TaskEvaluation } from './taskEvaluation';
import type { TaskResources } from './taskResources';
import type { TaskSubmission } from './taskSubmission';
import type { TaskRubric } from './taskRubric';
import type { TaskEventConfig } from './taskEventConfig';
import type { TaskMcqConfig } from './taskMcqConfig';
import type { TaskOralExamConfig } from './taskOralExamConfig';

/**
 * Task model without sensitive fields like grading rubric
 */
export interface Task {
  id: string;
  moduleId: string;
  version: string;
  /** When set, this task was recreated with a new id because its type changed. */
  remintedFromTaskId?: TaskRemintedFromTaskId;
  /** Type of task: 'essay' (written response), 'activity' (no written response, e.g., collect material or complete an external assignment), 'event' (scheduled/meeting). */
  type?: TaskTypeEnum;
  /**
   * @minimum 1
   * @maximum 3
   */
  level: number;
  sortIndex: number;
  title: string;
  description: string;
  analysis?: TaskAnalysis;
  gradingSystem?: TaskGradingSystemProperty;
  evaluation?: TaskEvaluation;
  resources?: TaskResources;
  submission?: TaskSubmission;
  rubric?: TaskRubric;
  eventConfig?: TaskEventConfig;
  isDeliveredAsEvent?: boolean;
  mcqConfig?: TaskMcqConfig;
  oralExamConfig?: TaskOralExamConfig;
  isOralExam?: boolean;
  allowedAttachmentFormats?: string[];
  /** Evaluation dimensions the server scores for this task (rubric plus system-managed, or tenant eval_dimensions when there is no rubric). */
  scoredDimensionIds?: string[];
}
